import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    BuildingContactClient,
    BuildingContactView,
    ContactView,
    SearchAvailableBuildingContactsParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BuildingContactService {
    constructor(private readonly client: BuildingContactClient) {}

    async buildingContactSearchAvailable(body: SearchAvailableBuildingContactsParameters): Promise<ContactView[]> {
        return await lastValueFrom(this.client.buildingContactSearchAvailable(body));
    }

    async buildingContactUpdateCompany(id: number) {
        return await lastValueFrom(this.client.buildingContactUpdateContactCompany(id));
    }

    async save(body: BuildingContactView): Promise<BuildingContactView> {
        return await lastValueFrom(this.client.buildingContactSaveContact(body));
    }

    async remove(body: BuildingContactView): Promise<void> {
        await lastValueFrom(this.client.buildingContactRemoveContact(body));
    }
}
